import styled from "styled-components";
import { device } from "../../constants";

export const Section = styled.section`
  background: #000104;
  position: relative;
  overflow: hidden;
  min-height: 100vh;
  padding: 0 0 80px;
  margin-top: -80px;
`;

export const Container = styled.div`
  position: relative;
  z-index: 1;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;

  @media ${device.laptop} {
    padding: 0;
  }
`;

export const HeroBanner = styled.div`
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  margin-bottom: 40px;
  background: linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 50%, #16213e 100%);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%234E4B98' fill-opacity='0.08'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    opacity: 0.5;
  }
`;

export const HeroContent = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 180px 20px 60px;
  position: relative;
  z-index: 1;

  @media ${device.laptop} {
    padding: 210px 20px 80px;
  }
`;

export const HeroRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;

  @media ${device.laptop} {
    gap: 40px;
  }
`;

export const HeroImage = styled.div`
  flex-shrink: 0;
  width: 120px;
  height: 120px;
  background: linear-gradient(135deg, #CEFF00 0%, #9FE870 100%);
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 20px 60px rgba(206, 255, 0, 0.2);

  svg {
    width: 60px;
    height: 60px;
    color: #000;
  }

  @media ${device.laptop} {
    width: 160px;
    height: 160px;
    border-radius: 32px;

    svg {
      width: 80px;
      height: 80px;
    }
  }
`;

export const HeroText = styled.div`
  flex: 1;
  text-align: left;
`;

export const HeaderSection = styled.div`
  text-align: center;
  margin-bottom: 40px;
`;

export const IconWrapper = styled.div`
  display: none;
`;

export const HighlightBar = styled.div`
  display: none;
`;

export const Title = styled.h1`
  margin: 0 0 24px;
  font-weight: 700;
  font-size: 36px;
  text-align: center;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors["neutral-01"]};

  @media ${device.laptop} {
    font-size: 52px;
    margin-bottom: 32px;
  }
`;

export const Description = styled.div`
  max-width: 650px;
  margin: 0;

  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: ${({ theme }) => theme.colors["neutral-02"]};
    text-align: left;
    margin: 0;

    strong {
      color: #CEFF00;
      font-weight: 600;
    }
  }

  @media ${device.laptop} {
    p {
      font-size: 16px;
      line-height: 28px;
    }
  }
`;

export const DownloadLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  padding: 10px 20px;
  background: rgba(206, 255, 0, 0.1);
  border: 1px solid rgba(206, 255, 0, 0.3);
  border-radius: 8px;
  color: #CEFF00;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s;

  &:hover {
    background: rgba(206, 255, 0, 0.2);
    border-color: rgba(206, 255, 0, 0.5);
    transform: translateY(-1px);
  }

  svg {
    width: 18px;
    height: 18px;
    color: #CEFF00 !important;
    fill: #CEFF00 !important;
  }
`;

export const FormCard = styled.div`
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 32px 24px;

  @media ${device.laptop} {
    padding: 40px;
  }
`;

export const FormSection = styled.div`
  margin-bottom: 32px;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const FormSectionTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.4px;
  color: #9FE870;
  margin: 0 0 20px;
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    width: 18px;
    height: 18px;
    color: #9FE870 !important;
    fill: #9FE870 !important;
  }
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;

  @media ${device.laptop} {
    grid-template-columns: ${({ columns }) => columns === 2 ? '1fr 1fr' : '1fr'};
  }
`;

export const InputWrapper = styled.div`
  position: relative;

  &.has-error {
    margin-bottom: 8px;
  }
`;

export const InputLabel = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors["neutral-02"]};
  margin-bottom: 8px;
`;

export const Input = styled.input`
  width: 100%;
  height: 52px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 0 16px;
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
  font-size: 15px;
  transition: all 0.2s;

  &::placeholder {
    color: ${({ theme }) => theme.colors["neutral-03"]};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors["vivid-02"]};
    background: rgba(255, 255, 255, 0.08);
  }

  &.error {
    border-color: #ef4444;
  }
`;

export const ErrorMessage = styled.p`
  position: absolute;
  bottom: -20px;
  left: 0;
  color: #ef4444;
  margin: 0;
  font-size: 12px;
`;

export const SubmitButton = styled.button`
  width: 100%;
  height: 56px;
  border: none;
  border-radius: 28px;
  background: linear-gradient(135deg, ${({ theme }) => theme.colors["vivid-02"]} 0%, ${({ theme }) => theme.colors["branding-02"]} 100%);
  color: #000;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 32px;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(154, 230, 180, 0.3);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const InfoBox = styled.div`
  background: rgba(78, 75, 152, 0.1);
  border: 1px solid rgba(78, 75, 152, 0.3);
  border-radius: 8px;
  padding: 16px;
  margin-top: 24px;

  p {
    margin: 0;
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors["neutral-02"]};

    strong {
      color: ${({ theme }) => theme.colors["neutral-01"]};
    }
  }
`;

export const SuccessMessage = styled.div`
  text-align: center;
  padding: 60px 20px;

  svg {
    width: 64px;
    height: 64px;
    color: ${({ theme }) => theme.colors["vivid-02"]};
    margin-bottom: 24px;
  }

  h2 {
    font-size: 24px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors["neutral-01"]};
    margin: 0 0 16px;
  }

  p {
    font-size: 16px;
    line-height: 28px;
    color: ${({ theme }) => theme.colors["neutral-02"]};
    margin: 0;
    max-width: 500px;
    margin: 0 auto;
  }
`;
